import { CycleRaycast, useCursor } from "@react-three/drei"
import { useEffect } from "react"
import { useContext, useRef } from "react"

import AppContext from "../../hooks/AppConext"
import { Buildings } from "./Buildings"

export const MuseumComplex = ({ nodes }) => {
  const { selected, hovered, setHovered } = useContext(AppContext)

  const selectedRef = useRef(selected)

  useEffect(() => {
    selectedRef.current = selected
  }, [selected])

  const handleHover = (objects) =>
    setHovered(
      !selectedRef.current && objects[0] ? objects[0].object.name : null
    )

  useCursor(hovered)

  return (
    <>
      <CycleRaycast preventDefault={false} onChanged={handleHover} />
      <Buildings nodes={nodes} />
    </>
  )
}
